import { useSEO, buildBreadcrumbsJsonLd } from "../../lib/seo";
import { useSiteTexts } from "../../lib/siteTexts";
import { pageFaqJsonLd, useFaqs } from "../../lib/faqs";
import { COMPANY, SITE_URL } from "../../lib/constants";
import { MEDIA_BY_KEY } from "../../data/siteMedia";
import { PAGE_TEXTS } from "../../data/pageTexts";
import { InfoHero } from "./InfoHero";
import { AdviceEndCta, SourcesBox } from "./AdviceBlocks";
import { InfoLinks } from "./InfoExtras";
import { ProductSubnav } from "../product/ProductSubnav";
import { ProductFAQ } from "../product/ProductFAQ";
import { IsdeTeaser } from "../product/IsdeTeaser";
import { KbRelated } from "../kennisbank/KbRelated";

export const REVIEWED = "oktober 2026";

const articleLd = (seo, hero, path, image) => ({
  "@context": "https://schema.org", "@type": "Article", headline: hero.title, description: seo.body, image,
  inLanguage: "nl-NL", dateModified: "2026-10-29", mainEntityOfPage: SITE_URL + path,
  author: { "@type": "Organization", name: COMPANY.name, url: SITE_URL },
  publisher: { "@type": "Organization", "@id": `${SITE_URL}/#localbusiness`, name: COMPANY.name },
});

// Gedeelde opbouw van de V3-informatiepagina's: SEO, hero, subnavigatie, centrale FAQ, kennisbank, verwijzingen en eind-CTA.
export const InfoPage = ({ page, label, eyebrow, points, mediaKey, nav, onderwerp, faqTitle, endTitle, isdeText, sources, badge, jsonLd, kbCategory, linkHrefs, children }) => {
  const cfg = PAGE_TEXTS[page];
  const t = useSiteTexts(page);
  const seo = t(cfg.blocks.seo);
  const hero = t(cfg.blocks.hero);
  const faqs = useFaqs(cfg.path);
  const crumbs = [{ label: "Home", href: "/" }, { label, href: cfg.path }];
  const image = SITE_URL + MEDIA_BY_KEY[mediaKey].src;
  useSEO({ title: seo.title, description: seo.body, path: cfg.path, ogImage: image, jsonLd: jsonLd || articleLd(seo, hero, cfg.path, image),
    faqJsonLd: pageFaqJsonLd(faqs, cfg.path), breadcrumbs: buildBreadcrumbsJsonLd(crumbs) });
  return (
    <div data-testid={`info-page-${page}`}>
      <InfoHero crumbs={crumbs} eyebrow={eyebrow} block={hero} points={points} mediaKey={mediaKey} location={`info-${page}`} onderwerp={onderwerp} badge={badge} />
      <ProductSubnav items={nav} onderwerp={onderwerp} />
      {children}
      {isdeText && <IsdeTeaser path={cfg.path} text={isdeText} />}
      <ProductFAQ faqs={faqs} title={faqTitle} />
      <SourcesBox sources={sources} reviewed={REVIEWED} note="Bedragen, voorwaarden en technische waarden zijn indicatief. De definitieve uitvoering en prijs staan in uw offerte." />
      {kbCategory && <KbRelated category={kbCategory} onderwerp={onderwerp} />}
      <InfoLinks current={cfg.path} hrefs={linkHrefs} />
      <AdviceEndCta title={endTitle} location={`info-${page}`} onderwerp={onderwerp} />
    </div>
  );
};
